import { useState } from 'react';
import { useRecoilValue } from 'recoil';

import { AlertModalTypes, alertsModalPageTestIDs } from '@constants';
import { navigationService } from '@services';
import { userSettingsState } from '@store';

export const useANFTrigger = (anfState, prevent = false) => {
  const userSettings = useRecoilValue(userSettingsState);
  const [anfShown, setAnfShown] = useState(false);
  const { appAccessed } = userSettings;

  // Do not override any modal user actions
  // Also check valid data
  let shouldShow = true;
  const allAlerts = anfState?.data?.filter(anf => anf.url);
  const noAlerts = !allAlerts || allAlerts.length === 0;

  if (prevent || noAlerts || anfShown || !appAccessed) {
    shouldShow = false;
  }

  if (shouldShow && !anfShown) {
    setAnfShown(true);
  }

  if (anfShown && noAlerts) {
    setAnfShown(false);
  }

  if (shouldShow) {
    navigationService.navigate(alertsModalPageTestIDs.alertsModalPage, {
      type: AlertModalTypes.liveANF,
    });
  }
};
